import { Download, X } from 'lucide-react'
import { useEffect, useState } from 'react'
import { Button } from './ui'

interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>
}

export function InstallPrompt() {
  const [event, setEvent] = useState<BeforeInstallPromptEvent | null>(null)
  const [dismissed, setDismissed] = useState(false)

  useEffect(() => {
    if (sessionStorage.getItem('ops-console.install-dismissed') === '1') return
    const onBeforeInstall = (next: Event) => { next.preventDefault(); setEvent(next as BeforeInstallPromptEvent) }
    window.addEventListener('beforeinstallprompt', onBeforeInstall)
    return () => window.removeEventListener('beforeinstallprompt', onBeforeInstall)
  }, [])

  if (!event || dismissed) return null

  async function install() {
    const current = event
    if (!current) return
    await current.prompt()
    if ((await current.userChoice).outcome === 'accepted') setEvent(null)
  }

  function close() {
    sessionStorage.setItem('ops-console.install-dismissed', '1')
    setDismissed(true)
  }

  return <div className="fixed inset-x-3 bottom-[4.5rem] z-30 flex items-center gap-3 rounded-xl border border-panel-border bg-panel-raised p-3 shadow-xl sm:inset-x-auto sm:right-4 sm:w-96 lg:bottom-4"><Download className="h-5 w-5 shrink-0 text-accent-info" aria-hidden /><div className="min-w-0 flex-1"><p className="text-sm font-medium text-ink">Install Gateway Ops</p><p className="text-xs text-ink-muted">Add the console to your home screen for faster access.</p></div><Button variant="primary" className="shrink-0" onClick={() => void install()}>Install</Button><button type="button" aria-label="Dismiss install prompt" className="rounded p-1 text-ink-muted hover:bg-panel-muted" onClick={close}><X className="h-4 w-4" /></button></div>
}
